export default "__VITE_ASSET__d3b862c7__"